import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import {
  useEquipment,
  useEquipmentMide,
  useUser,
} from "@services/servicesGenericsTables";
import React, { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { OPTIONS_YES_NO } from "../iodo131/utils/constants";
import { InputAdornment } from "@mui/material";

const CountigGTIG = () => {
  const form = useFormContext();
  const { userList } = useUser();
  const { equipmentList } = useEquipment();
  const { currentCounting } = useAnalysis();
  const filteredProcedures = useFilteredProcedures("CON");
  const { loading } = useEquipmentMide();

  const countingValidValue = useMemo(
    () => form.watch("counting_valid_select"),
    [form]
  );

  const countingEquipment = useMemo(
    () => form.watch("counting_equipment"),
    [form]
  );

  return (
    <>
      {currentCounting.index !== undefined ? (
        <React.Fragment key={currentCounting.id}>
          <ResponsiveFormContainer columns={5}>
            <MAutocomplete
              name="counting_analyst"
              options={userList}
              label="Seleccione un analista"
              getOptionLabel={(option) => option.username || ""}
              validation={{ required: "El analista es requerido" }}
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              name="counting_procedure"
              options={filteredProcedures}
              label="Procedimiento MLPMA"
              getOptionLabel={(option) => `${option.numop}` || ""}
              /*               validation={{ required: "El procedimiento es requerido" }} */
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              key={`counting_equipment-${form.getValues("counting_equipment")}`}
              name="counting_equipment"
              options={equipmentList}
              label="Equipos y geometrías"
              getOptionLabel={(option) =>
                `${option.codigo} - ${
                  option.is_geometry 
                    ? (option.height || option.descripcion) 
                    : option.descripcion
                }` || ""
              }
              loading={loading}
              disabled={!currentCounting.canEdit}
              multiple={true}
            />

            <MTextField
              name="geometry_height"
              placeholder={"Altura geometría"}
              label={"Altura geometría"}
              type="number"
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">{"(mm)"}</InputAdornment>
                ),
              }}              
            />

            <MDatePicker
              key="counting_date"
              name="counting_date"
              pickerType="date"
              label="Fecha de contaje"
              disabled={!currentCounting.canEdit}
            />
            <MTextField
              name="first_counting_time"
              label="Tiempo de Contaje (s)"
              placeholder="Tiempo de Contaje (s)"
              fullWidth
              type="number"
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              key={JSON.stringify(form.getValues("counting_valid_select"))}
              name="counting_valid_select"
              options={OPTIONS_YES_NO}
              label="¿Ha habido variación de la ganancia durante el contaje?"
              getOptionLabel={(option) => option.label}
              disabled={!currentCounting.canEdit}
              stylesInput={
                countingValidValue?.value === 1
                  ? { backgroundColor: "#ef233c" }
                  : countingValidValue?.value === 0
                  ? { backgroundColor: "#a7c957" }
                  : undefined
              }
            />
          </ResponsiveFormContainer>
        </React.Fragment>
      ) : null}
    </>
  );
};

export default CountigGTIG;
